import React from "react";
import { FormattedMessage } from "react-intl";
import { Link, useParams } from "react-router-dom";

import { useGetInvoicePaymentStatusQuery } from "~/api";
import { Button as RedesignButton } from "~/common/redesign-v1/ui";
import { PaymentStatusMessage, RedesignPaymentStatusCard } from "~/components/common/payment-status-message";
import { Button } from "~/components/ui/button";
import { Layout } from "~/components/ui/layout";
import { Portlet, PortletTitle } from "~/components/ui/portlet";
import { useIntlDocumentTitle } from "~/hooks/use-document-title";
import type { NumericString } from "~/types/common";

export default function PaymentInvoiceStatus({ bareLayout = false }: { bareLayout?: boolean }) {
  useIntlDocumentTitle("pat.payments.online.payment");
  const { patient_id, invoice_id } = useParams<{
    patient_id: NumericString;
    invoice_id: NumericString;
  }>();

  const invoiceQuery = useGetInvoicePaymentStatusQuery({
    patientId: Number(patient_id),
    invoiceId: Number(invoice_id),
  });
  const invoiceStatus = invoiceQuery.data?.status;

  const goToPatient = invoiceStatus == "succeeded" ? `/pages/patient/${patient_id}` : null;

  return (
    <Layout chrome={!bareLayout}>
      {bareLayout ? (
        <RedesignPaymentStatusCard
          titleId="pat.payments.online.payment"
          query={invoiceQuery}
          action={
            goToPatient ? (
              <RedesignButton asChild>
                <Link to={goToPatient}>
                  <FormattedMessage id="pat.payments.payment_status.goto" />
                </Link>
              </RedesignButton>
            ) : null
          }
        />
      ) : (
        <Portlet as="main" className="tw-h-full">
          <PortletTitle iconClassName="icon-book-open">
            <FormattedMessage id="pat.payments.online.payment" />
          </PortletTitle>

          <div className="portlet-body tw-space-y-4 max-desktop:tw-text-center">
            <PaymentStatusMessage query={invoiceQuery} />

            {goToPatient ? (
              <Button asChild>
                <Link to={goToPatient}>
                  <FormattedMessage id="pat.payments.payment_status.goto" />
                </Link>
              </Button>
            ) : null}
          </div>
        </Portlet>
      )}
    </Layout>
  );
}
